import './Login.css'
import mobile from '../Images/mobile.png'
import password from '../Images/password.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import http from "../Services/httpService";
import Services from "../Services/Services";
import showPass from "../Images/showPass.png"
import { toast } from "react-toastify";

export default function Login() {
    let navigate = useNavigate();
    const formRef = useRef(null);
    const [isPosting, setIsPosting] = useState(false);
    const [form, setForm] = useState(
        {
            Username: "", Password: "" 
        });
    useEffect(() => {
        const jwt = http.getLocalJwt();
        if (jwt && jwt != "") {
            navigate('/main');
        }

    }, []);


    const handlePosting = async (e) => {
        e.preventDefault();
        const forms = formRef.current;
        if (forms.checkValidity() === false) {
            toast.error('داده های ورودی را بررسی بفرمایید', { theme: "colored" });
            forms.classList.add('was-validated')
            return;
        }
        setIsPosting(true);
        await Services.login(form)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                http.setLocalJwt(data.payload.accessToken);
                navigate('/main');
            })
            .catch(err => {
                setIsPosting(false);
            });
    }
      const [showPassword, setShowPassword] = useState(false);
  const togglePassword = () => setShowPassword(prev => !prev);

    return (
        <>

            <form ref={formRef} className=" needs-validation">
                <div className="input-group mb-3">
                    <div className="input-group-text" >
                        <img
                            src={mobile}
                            className=" " />
                    </div>
                    <input
                        asp-for="Username"
                        type="text"
                        name="Username"
                        value={form.Username}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control"
                        placeholder="نام کاربری"
                        required
                        autoComplete="off" />
                    <span
                        asp-validation-for="Username"
                        className="text-danger" />
                    {/*<div className="invalid-feedback">
                        نام کاربری اجباری می باشد
                    </div>*/}
                </div>
                <div className="input-group mb-3 input-groupCustom">
                    <div className="input-group-text" >
                        <img
                            src={password}
                            className=" " />
                    </div>
                    <input
                        asp-for="Password"
                        id="inputPassword"
                        type={showPassword ? "text" : "password"}
                        name="Password"
                        value={form.Password}
                        onChange={e => http.handleChange(e, form, setForm)}
                        className="form-control "
                        placeholder="کلمه عبور"
                        required
                        autoComplete="off" />
                    <div className="input-group-text input-group-text-Custom" 
                    onClick={togglePassword}>
                        <img
                            src={showPass}
                            className=" " />
                    </div>
                    <span
                        asp-validation-for="Password"
                        className="text-danger" />
                </div>
                <div className='row'>
                    <div className='col'>
                        <button
                            className="w-100 btn btn-lg btn1 py-3"
                            onClick={handlePosting}
                            disabled={isPosting}>
                            ورود
                            {isPosting &&
                                <div className="spinner-border spinner-border-sm" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>}
                        </button>
                    </div>
                    <div className='col'>
                        <Link
                            className="w-100 btn btn-lg btn2 py-3 text-decoration-none"
                            disabled={isPosting}
                            to="/register">
                            ثبت نام
                        </Link>
                    </div>
                </div>
            </form>
            <div className="row mt-4">
                <div className="col d-flex justify-content-center">
                    <span className="text-white"> رمز خود را فراموش کرده اید؟</span>
                    <Link
                        className="textColor1 text-decoration-none ms-1"
                        to="/forgot">فراموشی رمز</Link>
                </div>
            </div>
        </>

    );

}
